const QSERV_ENDPOINT = 'https://gql-9src4t93q6.herokuapp.com';
// const QSERV_ENDPOINT = process.env.QSERV_ENDPOINT || 'http://localhost:4000';

export default QSERV_ENDPOINT;
